export const mapFieldType = (typeId) => {
  const typeMap = {
    1: 'string',
    2: 'email',
    4: 'number',
    5: 'birthdate',
    6: 'phone',
    7: 'checkbox',
    8: 'radio',
    9: 'select',
    10: 'file',
  };
  return typeMap[typeId] || 'string';
};
